import React from "react";
import { Spin, Descriptions } from "antd";
import AsideBlock from "../../../../../invigilationLog/components/AsideBlock";
import {
    ExamListItem,
    InvigilationStuListItem
} from "../../../../../../../service/exam";

interface Props {
    infoData: ExamListItem | null;
    loading: boolean;
    activeItem: InvigilationStuListItem | null;
}
export default function Aside({ infoData, loading, activeItem }: Props) {
    return (
        <AsideBlock title="考核信息">
            <Spin spinning={loading}>
                {infoData && (
                    <Descriptions
                        layout="vertical"
                        bordered
                        column={1}
                        size="small">
                        <Descriptions.Item label="考核名称">
                            {infoData?.name}
                        </Descriptions.Item>
                        <Descriptions.Item label="考试开始时间">
                            {infoData?.startTime}
                        </Descriptions.Item>
                        <Descriptions.Item label="考试结束时间">
                            {infoData?.endTime}
                        </Descriptions.Item>
                        <Descriptions.Item label="考试时长">
                            {infoData?.duration} 分钟
                        </Descriptions.Item>
                        {activeItem && (
                            <>
                                {/*<Descriptions.Item label="主监考">*/}
                                {/*    {activeItem?.masterTeacherName} -*/}
                                {/*    {activeItem?.masterTeacherId}*/}
                                {/*</Descriptions.Item>*/}
                                <Descriptions.Item label="监考">
                                    {activeItem?.assistantTeacherName}
                                </Descriptions.Item>
                            </>
                        )}
                    </Descriptions>
                )}
            </Spin>
        </AsideBlock>
    );
}
